import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Table } from 'react-bootstrap'

@observer(['globals'])
export default class PaymentConfirmation extends Component {

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="checkout-container">
        <h1>Payment Confirmation</h1>
        <p>
          Thank you for choosing GPS Leaders. Your payment has been processed and an email has been sent to you with a paid invoice attached. Our fulfillment department has been notified about your order and it will be shipped shortly.
        </p>
        <h2>
          Want free shipping on your next order?
        </h2>
        <p>
          <span className="strong-red">Click <a target="_blank" href="https://www.google.com/search?q=gps+leaders&oq=gps+leaders&aqs=chrome..69i57j69i60l3j0l2.3231j0j8&sourceid=chrome&ie=UTF-8#lrd=0x80db7c5394ee2a9d:0x225cb0c68ed10c14,1,,,">here</a> to create a review of our products and services and we will give you free ground shipping on your next order!</span>
        </p>
        <h2>
          Want to earn some extra cash?
        </h2>
        <p>
          <span className="strong-red">Click <a target="_blank" href=" https://gpsleaders.com/login/">here</a> to refer someone and earn the following:</span>
        </p>
        <Table striped bordered condensed hover>
          <thead>
            <tr>
              <th>If they purchase...</th>
              <th>... Then you get:</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1-4 Units</td>
              <td>$25.00</td>
            </tr>
            <tr>
              <td>5-9 Units</td>
              <td>$50.00</td>
            </tr>
            <tr>
              <td>10-24 Units</td>
              <td>$100.00</td>
            </tr>
            <tr>
              <td>25-49 Units</td>
              <td>$250.00</td>
            </tr>
            <tr>
              <td>50 or more Units</td>
              <td>$500.00</td>
            </tr>
          </tbody>
        </Table>
        <p>
          If you have any questions, please do not hesitate to contact us!
        </p>
        <p>
          Return to <a href="http://gpsleaders.com">GPS Leaders</a>
        </p>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/invoices/paymentconfirmation.js